import { debug } from 'console';
import { useEffect, useState } from 'react';
/*import './list.css';*/

const WishListButton = (props: any) => {
    const $$: any = $; 
    const { item: { itemID, addedToWishList, wishListID }, onUpdateWishList } = props;

    const [isAdded, setIsAdded] = useState(addedToWishList || false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [currentItemId, setCurrentItemId] = useState(itemID);
    const [formValues, setFormValues] = useState({ WishListName: '', WishListEmail: '' });

    const openWishListPopup = (id: any) => {
        setCurrentItemId(() => id);
        if (JSON.parse($$.cookie("wishListKey")) == null) {
            setShowLoginModal(()=> true)
        }
        else {
            SubmitDataDirecct(id);
        }
    }

    const SubmitDataDirecct = (itmId:any)=> {
        const email = JSON.parse($$.cookie("wishListKey")).email;
        const name = JSON.parse($$.cookie("wishListKey")).name;

        const id = itmId;
        const formData = new FormData();
        formData.append("Name", name);
        formData.append("Email", email);
        formData.append("ItemId", id);

        $$.ajax({
            type: 'POST',
            url: '/Item/ItemInwishList/' + 0,
            data: formData,
            processData: false,
            contentType: false
        }).done(function (response:any) {
            if (response) {
                if (response == true) {
                    setIsAdded(() => true);
                    onUpdateWishList && onUpdateWishList();
                    return;
                }

                setIsAdded(() => false);
            }
        });
    }

    const SubmitFormData = () => {
        if (formValues.WishListName == '' && formValues.WishListEmail == '') {
            $("#messagediv").empty();
            $("#messagediv").append('<p style="color:red;">Please Fill Name & Email</p>');
            return false;
        }

        const itmID = currentItemId;
        const email: any = formValues.WishListEmail;
        
        const formData:any = new FormData();
        formData.append("Name", formValues.WishListName);
        formData.append("Email", email);
        formData.append("ItemId", itmID);
        formData.append("IsWishList", $("#IsWishList").val());

        
        
        $.ajax({
            type: 'POST',
            url: '/Item/ItemInwishList/' + itmID,
            data: formData,
            processData: false,
            contentType: false
        }).done(function (response) {
            if (response) {
                clearField();

                setShowLoginModal(() => false)
                if (response == true || response.wishListName.length>0) {
                    setShowLoginModal(() => false)
                    setIsAdded(() => true);
                    setCookies(email);
                    return;
                }

                
                setIsAdded(() => false);
                deleteItemFromWishList();
            }
            else {
                alert("Invalid Form data!");
            }
        });

    }

    const clearField = () => {
        setFormValues(() => { return { WishListName: '', WishListEmail: '' } })
    }

    const Emptyvalues = () => {
        clearField();
        setShowLoginModal(() => false)
    }

    const onHandleAdd = () => {
        if (isAdded) {
            deleteItemFromWishList()
            return;
        }
        openWishListPopup(currentItemId);
    }

    const deleteItemFromWishList = () => {
        var email = JSON.parse($$.cookie("wishListKey")).email;
        var formData = new FormData();
        formData.append("Id", wishListID);
        formData.append("Email", email);

        $.ajax({
            type: 'POST',
            url: '/Item/DeleteItemFromWishList/' + 0,
            data: formData,
            processData: false,
            contentType: false
        }).done(function (response) {
            if (response) {
                {
                    setIsAdded(()=> false)
                }
            }
        });
    }
        
    const updateFormValues = (evt: any) => {
        if (evt) {
            const { id, value } = evt.target;
            setFormValues((prev: any) => {
                return {
                    ...prev,
                    [id]: value
                }
            })
        }
    }

    const setCookies = (email:string) => {
        const formData = new FormData();
        formData.append("Email", email);

        $.ajax({
            type: 'POST',
            url: '/Item/SetCookiesForWishList/' + 0,
            data: formData,
            processData: false,
            contentType: false
        }).done(() => {
            onUpdateWishList && onUpdateWishList();
        });
    }

    useEffect(() => {
        setIsAdded(() => addedToWishList);
    }, [itemID, addedToWishList, wishListID])

    return (
        <>
            <div style={{
                position: 'absolute',
                right: '-4px',
                top:'4px',
                justifyContent: 'right',
                cursor: 'pointer'
            }} onClick={onHandleAdd}>{isAdded ? <img className="px-1" src="/img/added.png" title="added" alt="" /> : <img className="px-1" title="add" src="/img/add.png" alt="" />}</div>

            {showLoginModal &&
                <div className="modal show wishlist-modale wishlist-model show" id="wishlist-model" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ display: 'block' }}
                >
                                    
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="quote-title m-0" id="exampleModalLabel">Create Wishlist</h5>

                            </div>
                            <div className="modal-body rounded-bottom">
                                <span id="message"></span>
                                <span id="message1"></span>
                                <div id="WishListForm" className="form-example">
                                    <input type="hidden" id="ItemId" value="@Model.ItemId" />
                                    <input type="hidden" value="true" id="IsWishList" name="IsWishList" />

                                    <div className="mb-3">
                                        <label className="mb-2" htmlFor="name">Name your wishlist</label>
                                        <input className="form-control" id="WishListName" onChange={updateFormValues} placeholder="eg. jewel ideas" name="name" required />

                                    </div>
                                    <div className="mb-3">
                                        <label className="mb-2" htmlFor="email">Email Address</label>
                                        <input type="email" className="form-control" id="WishListEmail" onChange={updateFormValues} placeholder="eg.jhondoe@abc.com" name="email" required />


                                    </div>

                                    <div className="mb-3" id="messagediv"></div>
                                    <div className="form-example submit-box">
                                        <button type="button" style={{ display: 'inline-block', padding: '5px 8px', marginTop: '30px', width: '87px', backgroundColor: 'white', color: 'black', border: '2px solid #159191' }} className="button btn-1 mb-4" onClick={Emptyvalues} >Close</button>
                                        <button onClick={SubmitFormData} style={{ display: 'inline-block', padding: '5px 8px', marginTop: '30px', width: '87px', backgroundColor: '#159191', color: 'white', border:'2px solid #159191' }} className="button quote mb-4 btn-2 ms-3">Save</button>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export default WishListButton;